var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.data.type === "SAP"
        ? _c("p", { staticClass: "number color2" }, [
            _vm._v(" " + _vm._s(_vm.data.quantity) + " "),
          ])
        : _vm._e(),
      _vm.data.type === "filled"
        ? _c(
            "div",
            [
              !_vm.isEditing
                ? _c(
                    "b-dropdown",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "trigger",
                            fn: function ({}) {
                              return [
                                _c("p", { staticClass: "number" }, [
                                  _vm._v(" " + _vm._s(_vm.data.quantity) + " "),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        969370309
                      ),
                    },
                    [
                      _c("b-dropdown-item", { on: { click: _vm.edition } }, [
                        _vm._v(" " + _vm._s(_vm.$t("global.update")) + " "),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.data.type === "error"
        ? _c(
            "div",
            {},
            [
              !_vm.isEditing
                ? _c(
                    "b-dropdown",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "trigger",
                            fn: function ({}) {
                              return [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "exclamation-circle",
                                    type: "is-warning",
                                    size: "is-medium",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1693131247
                      ),
                    },
                    [
                      _c("b-dropdown-item", { on: { click: _vm.edition } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("pages.new_crates.fill")) + " "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.isEditing
        ? _c("b-input", {
            ref: "nb",
            attrs: { placeholder: "Number", size: "is-small", type: "number" },
            on: { input: _vm.onInput, blur: _vm.onBlur },
            nativeOn: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return $event.target.blur()
              },
            },
            model: {
              value: _vm.data.quantity,
              callback: function ($$v) {
                _vm.$set(_vm.data, "quantity", $$v)
              },
              expression: "data.quantity",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }